module.exports = __webpack_public_path__ + "static/media/IMG_0849.55f55b22.JPG";